import { render, staticRenderFns } from "./DashboardTaskStatusAndListing.vue?vue&type=template&id=791fffdf"
import script from "./DashboardTaskStatusAndListing.vue?vue&type=script&lang=js"
export * from "./DashboardTaskStatusAndListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports